var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getConfigVar } from "../../utils/Configuration";
import { concatClassNames } from "../../utils/Functions";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function () {
            var onClose = _this.props.onClose, close = function () { return _this.setState({ closed: true }); };
            if (!onClose)
                return close();
            var result = onClose();
            if (result != null) {
                if (typeof result === "boolean" && result)
                    close();
                else if (result.then)
                    result.then(function (r) { return r && close(); });
            }
        };
        _this.render = function () {
            var _a = _this.props, color = _a.color, title = _a.title, closable = _a.closable, className = _a.className, style = _a.style, children = _a.children, alertColor = color || "blue", closed = _this.state.closed;
            if (closed)
                return React.createElement(React.Fragment, null);
            return React.createElement("div", { className: concatClassNames(["dolfo-alert", "color-" + alertColor], className), style: style },
                (title || closable) && React.createElement("h6", null,
                    React.createElement("span", null, title),
                    closable && React.createElement(Tooltip, { label: getConfigVar("CLOSE") },
                        React.createElement(Button, { shape: "text", color: alertColor, onClick: _this.close, className: "alert-close" },
                            React.createElement(FontAwesomeIcon, { icon: faXmark })))),
                children);
        };
        _this.state = {
            closed: false
        };
        return _this;
    }
    return Alert;
}(React.Component));
export { Alert };
